import React from 'react';
import {
  ResponsiveContainer,
  BarChart as RBarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Legend,
  Tooltip,
} from 'recharts';

const BarChart = (props) => {
  return (
    <ResponsiveContainer width="100%" height="100%">
      <RBarChart
        data={props.data}
        margin={{
          top: 5,
          bottom: 5,
          right: 30,
          left: 20,
        }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="label" />
        <YAxis />
        <Tooltip />
        <Bar dataKey="value" fill="#8884d8" />
      </RBarChart>
    </ResponsiveContainer>
  );
}

export default BarChart;
